module.exports = __webpack_public_path__ + "static/media/filter.2de75a64.svg";